import { isPlatform } from '@ionic/react';

export const isNative = () => {
  return !(isPlatform('desktop') || isPlatform('mobileweb'));
};
